import { render, staticRenderFns } from "./HospitalList.vue?vue&type=template&id=4cbf46b1&scoped=true&"
import script from "./HospitalList.vue?vue&type=script&lang=js&"
export * from "./HospitalList.vue?vue&type=script&lang=js&"
import style0 from "./HospitalList.vue?vue&type=style&index=0&id=4cbf46b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbf46b1",
  null
  
)

export default component.exports